const HASH_SHIFT = 5;

const hashString = (str: string): string => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << HASH_SHIFT) - hash + char;
  }
  return hash.toString();
};

export { hashString };
